import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { AuthDataInterface } from '../../auth/auth';
import { AuthGroupTypesEnum } from '../../auth/auth-group-types.enum';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CheckListsCommonService {
  constructor(private authService: AuthService) {}

  isAdministrator(): Observable<boolean> {
    return this.authService.subscribeAuthData().pipe(
      map((authData: AuthDataInterface) => {
        return authData.current_group.id === AuthGroupTypesEnum.Admin;
      })
    );
  }

  isCuratorOrDispatcher(): Observable<boolean> {
    return this.authService.subscribeAuthData().pipe(
      map((authData: AuthDataInterface) => {
        return (
          authData.current_group.id === AuthGroupTypesEnum.Curator ||
          authData.current_group.id === AuthGroupTypesEnum.Dispatcher ||
          authData.current_group.id === AuthGroupTypesEnum.Admin
        );
      })
    );
  }

  isCuratorOrDispatcherGRRS(): Observable<boolean> {
    return this.authService.subscribeAuthData().pipe(
      map((authData: AuthDataInterface) => {
        return (
          authData.current_group.id === AuthGroupTypesEnum.Curator ||
          authData.current_group.id === AuthGroupTypesEnum.DispatcherGRS ||
          authData.current_group.id === AuthGroupTypesEnum.Admin
        );
      })
    );
  }
}
